import { AxiosInstance } from "axios";
import { GetDangerZonesListResponse } from "./DangerZones.type";

export default class DangerZonesServices {
  private axios: AxiosInstance;
  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  // GET ALL DANGER ZONES
  public async GetAllDangerZonesList(): Promise<GetDangerZonesListResponse> {
    const url: string = "/danger-areas/all";
    return this.axios.get(url);
  }
}
